import React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import TagManager from 'react-gtm-module';
import MusicAppreciation from './pages/MusicAppreciation';
import CelebrityDetail from './pages/CelebrityDetail';
import GenreDetail from './pages/GenreDetail';
import { MUSIC_APPRECIATION, CELEBRITY, GENRE } from './index';
import { checkBrowser } from './utils/helpers';
import 'rc-slider/assets/index.css';

export const mode = `${process.env.REACT_APP_SOURCE_TYPE}`;

const checkiOS = checkBrowser('iOS', 'Safari', 11);
const checkAndroid = checkBrowser('Android', 'Chrome', 64);
const checkChrome = checkBrowser(null, 'Chrome', 56);
const checkEdge = checkBrowser(null, 'Edge', 16);
const checkFirefox = checkBrowser(null, 'Firefox', 51);
const checkSafari = checkBrowser(null, 'Safari', 11);
const checkIE = checkBrowser(null, 'IE', 11);
export const unsupported = checkiOS || checkAndroid || checkChrome || checkEdge || checkFirefox || checkSafari || checkIE;

export const dataLayer = window.dataLayer = window.dataLayer || [];

const GlobalStyle = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    font-family: system-ui, Microsoft JhengHei, sans-serif;
  }

  *:focus{
      outline: none;
  }

  body {
    background-color: black;
  }

  .App {
    position: relative;
  }

  .slick-slide {
    -webkit-transform: scale(0.90);
    -moz-transform: scale(0.90);
    transform: scale(0.90);
    transition: all 0.8s;

    &.slick-center {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transform: scale(1);
    }
  }

  .slick-next, .slick-prev {
    margin-top: -32px;
  }

  .slick-prev {
    left: -35px;
  }

  .slick-dots {
    bottom: 0;

    button:before {
      color: ${props => props.theme.colors.primary} !important;
      font-size: 10px !important;
    }
  }
  
  .slick-list> div {
    margin-left:0;
  }

  .rc-slider-handle {
    border-color: black;
    background-color: black;
  }

  .video-js .vjs-control-bar {
    background-color: black !important;
  }

  .video-js .vjs-control-bar, 
  .video-js .vjs-big-play-button, 
  .video-js .vjs-modal-dialog {
    color: ${props => props.theme.colors.primary};
  }

  .mobile {
    vertical-align: middle;
  }

  .desktop {
    display: none;
  }

  .only-landscape {
    display: none;
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 50;
  }

  .phone {
    height: 50px;
    width: 100px;
    border: 3px solid white;
    border-radius: 10px;
    animation: rotate 1.5s ease-in-out infinite alternate;
    /* display: none; */
  }

  .message {
    color: white;
    font-size: 1em;
    margin-top: 40px;
    /* display: none; */
  }

  .__react_component_tooltip.show {
    white-space: nowrap;
  }

  @media only screen and (min-width: 800px) {
    .mobile {
      display: none;
    }

    .desktop {
      display: block;
    }
  }
  
  @keyframes pump {
    0% { transform: scale(1);}
    16% { transform: scale(1);}
    20% { transform: scale(1.05);}
    24% { transform: scale(1);}
    30% { transform: scale(1);}
    35% { transform: scale(1.05);}
    40% { transform: scale(1);}
    100% { transform: scale(1);}
  }

  @keyframes heart {
    0% { transform: translate(0, 0) scale(1); }
    65% { transform: translate(0, -28vh) scale(1); }
    70% { transform: translate(0, -30vh) scale(1.2); }
    75% { transform: translate(0, -32vh) scale(0); }
    90% { transform: translate(0, 6vh) scale(0); }
    95% { transform: translate(0, 2vh) scale(1.2); }
    100% { transform: translate(0, 0) scale(1); }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg)
    }
    50% {
      transform: rotate(-90deg)
    }
    100% {
      transform: rotate(-90deg)
    }
  }

  @media screen and (orientation: landscape) and (-webkit-device-pixel-ratio : 3) {
    .only-landscape {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  @media screen and (orientation: landscape) and (max-width: 800px) {
    .only-landscape {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: #bbb;
    border: 1px none #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #bbb;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #bbb;
  }
  ::-webkit-scrollbar-track {
    background: #ffffff;
    border: 1px none #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #fff;
  }
  ::-webkit-scrollbar-track:active {
    background: #fff;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

export const timestemp = Math.round(new Date().getTime()/1000);

const theme = {
  colors: {
    primary: '#D79013',
    heading: '#D79013',
    text: 'white',
    player: '#f0f1eb',
    border: '#535151'
  },
  font: {
    size: '24px',
  }
};

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
    auth: process.env.REACT_APP_GTM_ENV_AUTH,
    preview: process.env.REACT_APP_GTM_ENV_PREVIEW
}

TagManager.initialize(tagManagerArgs);

const App = ({ page, cslExclusive24bit }) => {
  console.log(cslExclusive24bit);
    return (
      <ThemeProvider theme={theme}>
        <div className="App">
          {page === MUSIC_APPRECIATION && <MusicAppreciation cslExclusive24bit={cslExclusive24bit} />}
          {page === CELEBRITY && <CelebrityDetail cslExclusive24bit={cslExclusive24bit} />}
          {page === GENRE && <GenreDetail cslExclusive24bit={cslExclusive24bit} />}
          <GlobalStyle />
          <div className="only-landscape">
            <div className="phone" />
            <div className="message">
              請以垂直方式使用此網頁
            </div>
          </div>
        </div>
      </ThemeProvider>
    )
};

export default App;
